import { DefaultService } from '@/services/DefaultService';

export default class GrupoPermissaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(permissao) {
        return this._http.post(`${this._env}/authorizationgroup`, permissao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/authorizationgroup/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/authorizationgroup/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    ativar(id) {
        return this._http.post(`${this._env}/authorizationgroup/${id}`, {}, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/authorizationgroup.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findByUserId(id) {
        return this._http.get(`${this._env}/authorizationgroup/user/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}